import { Language } from "./enums";

export const LOCAL_STORAGE_KEY = 'cvh-lang';
export const SUPPORTED_LANGUAGES = ["en", "fr"];
